import { render, staticRenderFns } from "./parse.vue?vue&type=template&id=02524ab2&scoped=true&"
import script from "./parse.vue?vue&type=script&lang=js&"
export * from "./parse.vue?vue&type=script&lang=js&"
import style0 from "./parse.vue?vue&type=style&index=0&id=02524ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02524ab2",
  null
  
)

export default component.exports